<template>
  <el-select
    v-loading="loading"
    v-model="DepSelected"
    clearable
    :size="fieldSize"
    placeholder="Departamento"
    @change="hanldeSelection"
    v-bind="$attrs"
    :disabled="isItDisable"
    :loading="dataLoading"
  >
    <el-option
      v-for="item in Deparments"
      :key="item.Id"
      :label="item.Name"
      :value="item.Id"
    >
    </el-option>
  </el-select>
</template>

<script>
export default {
  props: {
    DirecctionID: {
      type: Number,
      required: true
    },
    fieldSize: {
      type: String,
      default: "large",
      required: false
    },
    initialDirection: {
      type: Number,
      default: 0,
      required: false
    },
    initialDeparment: {
      type: Number,
      default: 0,
      required: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    DirecctionID(dir) {
      this.DepSelecte = "";
      this.LoadingOn();
      this.getData(dir);
    },
    initialDeparment(val) {
      if (val === 0) {
        this.DepSelected = "";
      } else {
        this.DepSelected = val;
      }
    }
  },
  created() {
    this.getData(this.initialDirection);
    this.LoadingOff();
    this.DepSelected = this.initialDeparment === 0 ? "" : this.initialDeparment;
  },
  data() {
    return {
      DepSelected: "",
      Deparments: [],
      loading: true,
      dataLoading: false
    };
  },
  computed: {
    isItDisable() {
      return this.isDisabled;
    }
  },
  methods: {
    LoadingOn() {
      this.loading = true;
    },
    LoadingOff() {
      this.loading = false;
    },
    getData(dir) {
      this.dataLoading = true;
      this.LoadingOn();
      const uri = `/api/deparments/GetAllDeparmentByDirectionId?DirectionID=${dir}`;
      this.Deparments = [];
      this.$http
        .get(uri)
        .then((response) => {
          this.Deparments = response.data;
          this.LoadingOff();
        })
        .catch(() => {
          this.LoadingOff();
        })
        .finally(() => {
          this.dataLoading = false;
          this.LoadingOff();
        });
    },
    hanldeSelection() {
      if (this.DepSelected) {
        this.$emit("selectionChange", this.DepSelected);
      } else {
        this.$emit("selectionChange", 0);
      }
    }
  }
};
</script>

<style></style>
